<template>
	<header :class="[classes, { bb: setBorder }]" data-context="header">
		<div class="display-none-md container">
			<div class="page__header-inner display-flex justify-content-space-between">
				<BaseLink v-if="enableHomeLink" data-test="fundrise-logo-mobile" :link="{ router: logoRoute }">
					<img :src="logoImgUrl" style="width: 137px" alt="Fundrise logo" />
				</BaseLink>
				<img v-else :src="logoImgUrl" style="width: 137px" alt="Fundrise logo" />
				<BaseButton
					v-if="cancelModal"
					data-test="cancel-modal-mobile"
					classes="text-color-current-color link"
					:click-text="cancelClickText"
					@click="openModal()"
				>
					<span class="show-for-sr">Cancel</span>
					<BaseSvgIcon name="close" />
				</BaseButton>
				<BaseLink
					v-else-if="cancelLink"
					data-test="cancel-link-mobile"
					classes="text-color-current-color link"
					:click-text="cancelClickText"
					:link="cancelLink"
				>
					<span class="show-for-sr">Cancel</span>
					<BaseSvgIcon name="close" />
				</BaseLink>
			</div>
		</div>
		<div class="display-none-smo container">
			<div class="page__header-inner display-flex align-items-center justify-content-space-between">
				<div class="display-flex align-items-center">
					<BaseLink v-if="enableHomeLink" data-test="fundrise-logo-desktop" :link="{ router: logoRoute }">
						<img :src="logoImgUrl" style="width: 137px" alt="Fundrise logo" />
					</BaseLink>
					<img v-else :src="logoImgUrl" style="width: 137px" alt="Fundrise logo" />
					<slot />
				</div>
				<BaseButton
					v-if="cancelModal"
					data-test="cancel-modal-desktop"
					classes="mr-300 text-color-current-color link"
					:click-text="cancelClickText"
					@click="openModal()"
				>
					<span class="show-for-sr">Cancel</span>
					<BaseSvgIcon name="close" />
				</BaseButton>
				<BaseLink
					v-else-if="cancelLink"
					data-test="cancel-link-desktop"
					classes="mr-300 text-color-current-color link"
					:click-text="cancelClickText"
					:link="cancelLink"
				>
					<span class="show-for-sr">Cancel</span>
					<BaseSvgIcon name="close" />
				</BaseLink>
			</div>
		</div>
	</header>
</template>
<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { computed } from 'vue';
import { CurrentModal } from 'types/modal';
import { Link } from 'types/layout';
import { useAppStore } from '@stores/app';

interface Props {
	cancelModal?: CurrentModal | null;
	cancelLink?: Link;
	classes?: string;
	cancelClickText?: string;
	enableHomeLink?: boolean;
	theme?: string;
	setBorder?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
	cancelModal: undefined,
	cancelLink: undefined,
	cancelClickText: undefined,
	classes: '',
	enableHomeLink: true,
	theme: 'light',
	setBorder: true
});

const appStore = useAppStore();

const logoImgUrl = computed((): string => {
	return props.theme === 'dark'
		? `${appCloudfrontPath}/interface/logo-hz-white.svg`
		: `${appCloudfrontPath}/interface/logo-hz-color.svg`;
});

const logoRoute = computed((): string => {
	return appStore.isAuthenticated && appStore.isVerified ? 'account-overview' : 'home';
});

function openModal(): void {
	appStore.updateCurrentModal(props.cancelModal ?? null);
}
</script>
